export default __webpack_public_path__ + "static/media/ZZC_7815.bd324acb.jpg";